// The screens' words, drawn as React elements (never as raw HTML), with the marks live's course
// site uses (its md() and scriptBlocks()): paragraphs, "## " and "### " headings, numbered and
// bulleted lists, "> " quotes, **bold**, *italic*, ==highlight== (in orange) and a run of ">>" lines,
// which is something to say out loud, in a block labelled "Say this" or by the first line's
// "[label]" ("[Ask the letting agent] If I put this on ...").
import { Fragment } from 'react'
import { mdBlocks } from './md.js'

// **bold**, *italic* and ==highlight==, nested as written
const INLINE = /(\*\*[^*]+?\*\*|==[^=]+?==|\*[^*\s][^*]*?\*)/
export function Inline({ text }) {
  const bits = String(text || '').split(INLINE).filter(b => b !== '')
  return bits.map((bit, i) => {
    if (/^\*\*[^*]+\*\*$/.test(bit)) return <strong key={i}><Inline text={bit.slice(2, -2)} /></strong>
    if (/^==[^=]+==$/.test(bit)) return <span key={i} className="ps-hl"><Inline text={bit.slice(2, -2)} /></span>
    if (/^\*[^*\s][^*]*\*$/.test(bit)) return <em key={i}><Inline text={bit.slice(1, -1)} /></em>
    return <Fragment key={i}>{bit}</Fragment>
  })
}

export function Md({ text, className = '' }) {
  const blocks = mdBlocks(text)
  if (!blocks.length) return null
  return (
    <div className={`ps-md ${className}`.trim()}>
      {blocks.map((b, i) => {
        if (b.kind === 'h2') return <h2 key={i}><Inline text={b.text} /></h2>
        if (b.kind === 'h3') return <h3 key={i}><Inline text={b.text} /></h3>
        if (b.kind === 'ol') return <ol key={i}>{b.items.map((t, j) => <li key={j}><Inline text={t} /></li>)}</ol>
        if (b.kind === 'ul') return <ul key={i}>{b.items.map((t, j) => <li key={j}><Inline text={t} /></li>)}</ul>
        if (b.kind === 'quote') return <blockquote key={i}><Inline text={b.text} /></blockquote>
        if (b.kind === 'script') {
          return (
            <div key={i} className="ps-script">
              <div className="ps-script-label">{b.label}</div>
              {b.lines.map((l, j) => <p key={j}><Inline text={l} /></p>)}
            </div>
          )
        }
        return <p key={i}><Inline text={b.text} /></p>
      })}
    </div>
  )
}
